export default __webpack_public_path__ + "static/generalEnglishMoreCourseDetails-aa3559bd8bf9c58f39ed458619715e9b.png";